import * as Headless from '@sail/theme-headless';
import {css, theme} from '../theme';

export const Tooltip = theme(Headless.Tooltip, [
  css({
    font: 'body',
    boxShadow: 'hover',

    [Headless.TooltipVariants.type.description]: {
      padding: 'medium',
      maxWidth: css.value('300px'),
      backgroundColor: 'surface',
      border: css.value('1px solid $borderColor.neutral'),
      borderRadius: 'medium',
    },

    [Headless.TooltipVariants.type.label]: {
      paddingX: 'small',
      paddingY: 'xsmall',
      maxWidth: css.value('200px'),
      backgroundColor: css.value('$color.neutral700'),
      color: css.value('$color.neutral0'),
      borderRadius: 'small',
    },

    [Headless.TooltipVariants.placement['top left']]: {
      marginBottom: 'xsmall',
    },
    [Headless.TooltipVariants.placement.top]: {
      marginBottom: 'xsmall',
    },
    [Headless.TooltipVariants.placement['top right']]: {
      marginBottom: 'xsmall',
    },

    [Headless.TooltipVariants.placement['right top']]: {
      marginLeft: 'xsmall',
    },
    [Headless.TooltipVariants.placement.right]: {
      marginLeft: 'xsmall',
    },
    [Headless.TooltipVariants.placement['right bottom']]: {
      marginLeft: 'xsmall',
    },

    [Headless.TooltipVariants.placement['bottom right']]: {
      marginTop: 'xsmall',
    },
    [Headless.TooltipVariants.placement.bottom]: {
      marginTop: 'xsmall',
    },
    [Headless.TooltipVariants.placement['bottom left']]: {
      marginTop: 'xsmall',
    },

    [Headless.TooltipVariants.placement['left bottom']]: {
      marginRight: 'xsmall',
    },
    [Headless.TooltipVariants.placement.left]: {
      marginRight: 'xsmall',
    },
    [Headless.TooltipVariants.placement['left top']]: {
      marginRight: 'xsmall',
    },
  }),
]);
